import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention */
import * as react from "react";
import { Tools } from "core/Misc/tools.js";
import { LineContainerComponent } from "../../sharedComponents/lineContainerComponent.js";
import { NodeLedger } from "shared-ui-components/nodeGraphSystem/nodeLedger.js";
import "../../assets/styles/components/nodeList.scss";
import { DraggableBlockLineComponent } from "../../sharedComponents/draggableBlockLineComponent.js";
import deleteButton from "../../assets/imgs/delete.svg";
import addButton from "../../assets/imgs/add.svg";
import { LineWithFileButtonComponent } from "../../sharedComponents/lineWithFileButtonComponent.js";
import { GetBlockKey } from "../../helpers/blockKeyConverters.js";
import { CustomBlocksNamespace } from "../../configuration/constants.js";
import { OnlyShowCustomBlocksDefaultValue } from "../../constants.js";
export class NodeListComponent extends react.Component {
    constructor(props) {
        super(props);
        this.state = { filter: "", onlyShowCustomBlocks: OnlyShowCustomBlocksDefaultValue };
        this._onOnlyShowCustomBlocksObserver = props.globalState.onlyShowCustomBlocksObservable.add((value) => {
            this.setState({
                onlyShowCustomBlocks: value,
            });
        });
        this._onResetRequiredObserver = this.props.globalState.onResetRequiredObservable.add(() => {
            this.forceUpdate();
        });
    }
    componentWillUnmount() {
        this.props.globalState.onResetRequiredObservable.remove(this._onResetRequiredObserver);
        this.props.globalState.onlyShowCustomBlocksObservable.remove(this._onOnlyShowCustomBlocksObserver);
    }
    filterContent(filter) {
        this.setState({ filter: filter });
    }
    loadCustomBlock(file) {
        Tools.ReadFile(file, async (data) => {
            if (!this.props.globalState.addCustomBlock) {
                return;
            }
            const decoder = new TextDecoder("utf-8");
            this.props.globalState.addCustomBlock(decoder.decode(data));
            this.forceUpdate();
        }, undefined, true);
    }
    deleteCustomBlock(block) {
        if (!this.props.globalState.deleteCustomBlock) {
            return;
        }
        this.props.globalState.deleteCustomBlock(block);
        this.forceUpdate();
    }
    render() {
        // Create node menu
        const blockMenu = [];
        const allBlocks = this.props.globalState.blockEditorRegistration ? this.props.globalState.blockEditorRegistration.allBlocks : {};
        for (const key in allBlocks) {
            const blockList = allBlocks[key].filter((block) => (!this.state.onlyShowCustomBlocks || block.isCustom || block.isInput) &&
                (!this.state.filter || block.blockType.toLowerCase().indexOf(this.state.filter.toLowerCase()) !== -1))
                .sort((a, b) => a.blockType.localeCompare(b.blockType))
                .map((block) => {
                if (block.isCustom) {
                    return (_jsx(DraggableBlockLineComponent, { block: block, iconImage: deleteButton, iconTitle: "Delete", onIconClick: () => {
                            this.deleteCustomBlock(block);
                        } }, GetBlockKey(block.blockType, block.namespace)));
                }
                return _jsx(DraggableBlockLineComponent, { block: block }, GetBlockKey(block.blockType, block.namespace));
            });
            let contextMenuItems = undefined;
            if (key === CustomBlocksNamespace) {
                const line = (_jsx(LineWithFileButtonComponent, { title: "Add Custom Block", closed: false, label: "Add...", uploadName: "custom-block-upload", iconImage: addButton, accept: ".json, .glsl", allowMultiple: true, onIconClick: (file) => this.loadCustomBlock(file) }, "add..."));
                blockList.push(line);
                if (this.props.globalState.clearCustomBlocks) {
                    const clearCustomBlocks = this.props.globalState.clearCustomBlocks;
                    contextMenuItems = [
                        {
                            key: "Remove_All_Custom_Blocks",
                            label: "Remove All Custom Blocks",
                            onClick: () => {
                                clearCustomBlocks();
                                this.forceUpdate();
                            },
                        },
                    ];
                }
            }
            if (blockList.length) {
                blockMenu.push(_jsx(LineContainerComponent, { title: key.replace("__", ": ").replace("_", " "), closed: false, contextMenuItems: contextMenuItems, children: blockList }, key + " blocks"));
            }
        }
        // Register blocks
        const ledger = NodeLedger.RegisteredNodeNames;
        ledger.length = 0; // clear the ledger
        for (const namespace in allBlocks) {
            const blockRegistrations = allBlocks[namespace];
            if (blockRegistrations && blockRegistrations.length) {
                for (const blockRegistration of blockRegistrations) {
                    if (!this.state.onlyShowCustomBlocks || blockRegistration.isCustom || blockRegistration.isInput) {
                        const blockKey = GetBlockKey(blockRegistration.blockType, blockRegistration.namespace);
                        ledger.push(blockKey);
                    }
                }
            }
        }
        NodeLedger.NameFormatter = (name) => {
            let finalName;
            // custom frame
            if (name.endsWith("Custom")) {
                const nameIndex = name.lastIndexOf("Custom");
                finalName = name.substring(0, nameIndex);
                finalName += " [custom]";
            }
            else {
                finalName = name.replace("Block", "");
            }
            return finalName;
        };
        return (_jsx("div", { id: "nodeList", children: _jsx("div", { className: "panes", children: _jsxs("div", { className: "pane", children: [_jsx("div", { className: "filter", children: _jsx("input", { type: "text", placeholder: "Filter", onFocus: () => (this.props.globalState.lockObject.lock = true), onBlur: () => {
                                    this.props.globalState.lockObject.lock = false;
                                }, onChange: (evt) => this.filterContent(evt.target.value) }) }), _jsx("div", { className: "list-container", children: blockMenu })] }) }) }));
    }
}
//# sourceMappingURL=nodeListComponent.js.map